const { getStageListRoot } = require('./stageListAdapter');

const WITHDRAWN_TEXT = 'проект отозван';

function toArr(x) {
	return x == null ? [] : Array.isArray(x) ? x : [x];
}

function isProjectWithdrawn(text) {
	return (text || '').trim().toLowerCase() === WITHDRAWN_TEXT;
}

function getStageListObject(record) {
	return getStageListRoot(record && record.stageList);
}

function getWithdrawalAttachmentsList(record) {
	if (!record) return [];
	const rel = record.withdrawalAttachments;
	if (typeof rel === 'function') return rel();
	if (Array.isArray(rel)) return rel;
	return [];
}

module.exports = {
	WITHDRAWN_TEXT,
	toArr,
	isProjectWithdrawn,
	getStageListObject,
	getWithdrawalAttachmentsList,
};
